const einrichtungKlient_en = {
  tours: {
    studentNamesOfSelectedTours: 'Clients of selected tours',
    errorNotification: {
      no_transportationModel: 'The affected clients have no standard week.',
      status: {
        ALREADY_IN_TOUR: 'The client is already assigned to this tour.',
        STUDENT_ALREADY_IN_TOUR: 'The client is already assigned to a tour.',
        LAST_STUDENT_IN_TOUR: 'The tour contains only this client.',
        INSUFFICIENT_REGULAR_SEATS:
          'The vehicle does not have enough regular seats for the client and required escorts.',
        INSUFFICIENT_WHEELCHAIR_SEATS:
          'The vehicle does not have enough wheelchair seats for the client.',
        MISSING_CALENDAR_EVENTS:
          'The client has no calendar events on at least one day when the tour operates.',
        INCOMPATIBLE_SCHEDULE:
          'The client schedule groupings are not compatible with the tour school-hour groupings.',
        STUDENT_ALREADY_IN_OVERLAPPING_TOUR:
          'The client is already scheduled in a tour for the selected time period.',
        MAX_TIME_IN_VEHICLE_CONSTRAINT:
          'You cannot add the client because this would exceed the maximum transportation ' +
          'time. Note: You can edit the maximum transportation time in the facility administration ' +
          'and then add the client to the tour.',
        SCHEDULE_NOT_SUITABLE:
          "Please check the client's calendar. No matching calendar events were found for at least one tour day.",
        STUDENT_DOES_NOT_FIT:
          'The client cannot be added because of the vehicle capacity, tour type, grouping, ' +
          'or specified transportation times.',
        NO_SCHEDULE:
          'Please check the client calendar. No events could be found ' +
          'at the time of the change.',
      },
      overlappingToursInfo:
        'Client {{studentId}} is already assigned to {{count}} overlapping tour(s) on {{date}}:',
      details: {
        studentId: {
          singular: 'Client ID',
          plural: 'Client IDs',
        },
        studentGroupings: 'Client groupings',
      },
    },
  },
  transportationPeriod: {
    helpInfoText:
      'The transportation period filters the client list using the dates in the Transportation from and Transportation until fields.',
  },
  student: {
    singular: 'Client',
    plural: 'Clients',
    studentsFromSelectedTours: 'Clients from selected tours',
    gender_MALE: 'Client',
    gender_FEMALE: 'Client',
    gender_DIVERS: 'Client',
    // ... english TODO on demand: only the labels that differ
  },
};

export default einrichtungKlient_en;
